var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInboxIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 475") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FOR-DEV",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dev-company-info",
    transform: "translate(-38.000000, -111.000000)",
    fill: "#CCCCCC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-475",
    transform: "translate(38.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,11 L19.393,11 C18.481,12.778 16.632,14 14.5,14 L11,14 L11,16 C11,17.654 12.346,19 14,19 L16.293,19 L19.146,21.854 C19.459,22.166 20,21.945 20,21.5 L20,19 L21,19 C22.654,19 24,17.654 24,16 L24,14 C24,12.346 22.654,11 21,11",
    id: "Fill-1431"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,8.5 L19,4.5 C19,2.019 16.981,0 14.5,0 L4.5,0 C2.019,0 0,2.019 0,4.5 L0,8.5 C0,10.981 2.019,13 4.5,13 L5,13 L5,16.5 C5,16.944 5.54,17.168 5.854,16.854 L9.707,13 L14.5,13 C16.981,13 19,10.981 19,8.5",
    id: "Fill-1432"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInboxIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/inbox_icon.40011091f827606cfb3b1efb91318480.svg";